import { getDarkenColor, getLightenColor } from "./";

export default (type, colors) => {
  const styles = {
    default: {
      'c-comment__textarea': {
        customCSS: `
          .c-comment--create .c-comment__textarea.state-dirty .c-comment__textarea,
          .c-comment--create .c-comment__textarea:focus {
            background: ${getDarkenColor(colors.light, 0.026)};
          }
          .c-comment--create.state-dirty .c-comment__textarea,
          .c-comment--create .c-comment__textarea:focus {
            box-shadow: inset 1px 1px ${getLightenColor(colors.secondary, 0.5)};
          }
        `
      },
      'c-comment__body': {
        customCSS: `
          .c-comment--create .c-comment__body:before {
            background: ${getLightenColor(colors.primary, 2.3)};
          }
        `
      },
      'c-comment__buttons': {
        customCSS: `
          .c-comment--create .c-comment__buttons:after {
            border-color: transparent ${getDarkenColor(colors.light, 0.026)} transparent transparent;
          }
        `
      }
    },
    type1: {
      'c-comment__textarea': {
        customCSS: `
          .c-comment--create .c-comment__textarea.state-dirty .c-comment__textarea,
          .c-comment--create .c-comment__textarea:focus {
            background: ${getDarkenColor(colors.light, 0.026)};
          }
          .c-comment--create.state-dirty .c-comment__textarea,
          .c-comment--create .c-comment__textarea:focus {
            box-shadow: inset 1px 1px ${getLightenColor(colors.secondary, 0.5)};
          }
        `
      },
      'c-comment__body': {
        customCSS: `
          .c-comment--create .c-comment__body:before {
            background: ${getLightenColor(colors.primary, 2.3)};
          }
        `
      },
      'c-comment__buttons': {
        customCSS: `
          .c-comment--create .c-comment__buttons:after {
            border-color: transparent ${getDarkenColor(colors.light, 0.026)} transparent transparent;
          }
        `
      }
    }
  }

  return styles[type]
}


// WEBPACK FOOTER //
// ./webapp/styles/dynamicStyles/cComment.js